import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import LoadBoard from "@/pages/LoadBoard";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/loads" element={<LoadBoard />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: { background: "#111A2E", border: "1px solid rgba(37,99,235,0.2)", color: "#F1F5F9" },
        }}
      />
    </div>
  );
}

export default App;
